import { createGuideStore } from "../createGuideStore";

export const useWelcomeGuideStore = createGuideStore("welcome-v1");
export const useInventoryGuideStore = createGuideStore("inventory-v1");
export const useTaskManagerGuideStore = createGuideStore("task-manager-v1");
export const useModelCatalogGuideStore = createGuideStore("model-catalog-v1");
export const useWorkspaceSettingsGuideStore = createGuideStore(
  "workspace-settings-v1",
);
export const useExplorationGuideStore = createGuideStore("exploration-v1");
export const useCreateDatasetGuideStore = createGuideStore("create-dataset-v1");
export const useAddMediaGuideStore = createGuideStore("add-media-v1");
